// @flow

import React from 'react';

import notification from 'antd/lib/notification';

import { washingApi } from '../../../../../lib/api';
import type { Washing } from '../../../../../lib/types';

import Filter from '../../../../services/washings/Filter';
import { WASHING_COLUMNS } from '../../../../services/washings';

import { ListTable } from '../../../lib';

export default class extends ListTable<Washing> {
  fetch = async (page: number = 1) => {
    const params = super.fetch(page);
    try {
      const data = await washingApi.fetchAllWashings(params);
      const totalSum = await washingApi.getTotalSum(params);
      this.setState({ ...data, totalSum, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        {super.renderFilter(Filter)}
        {super.renderTable(WASHING_COLUMNS)}
      </>
    );
  }
}
